
/**
 * Extracts user-friendly error message from year mutation errors
 */
export const extractYearErrorMessage = (error: any): string => {
  // Check for our custom validation error
  if (error instanceof Error && error.message.includes('Invalid year format')) {
    return error.message;
  }
  
  // Handle Supabase error object
  if (error && typeof error === 'object') {
    if ('message' in error) {
      return error.message as string;
    }
    if ('details' in error) {
      // Check for unique constraint violations
      if (error.details?.includes('already exists')) {
        return "This year already exists in the database.";
      }
      return error.details as string;
    }
    // Handle code-based errors
    if ('code' in error && error.code === '23505') {
      return "This year already exists in the database.";
    }
  }
  
  return "Failed to add year. Please try again.";
};
